<template>
  <div class="contact-page">

    <!-- 搜索弹窗 -->
    <div class="search" v-show="searchVisible">
      <div class="sc_bj">
        <div class="sc_gb" @click="toggleSearch"><i class="iconfont icon-guanbi1"></i></div>
        <div class="sc_nr">
          <input type="text" v-model="searchKeyword" placeholder="Please enter keywords">
          <button @click="handleSearch"><i class="iconfont icon-tubiaozhizuomoban"></i></button>
          <div class="clear"></div>
        </div>
      </div>
    </div>

    <!-- 页面横幅 -->
    <div class="ny_ban" style="background-image:url(/images/n_ban1.jpg);">
      <div class="container">
        <h1 class="wow fadeInLeft" data-wow-delay=".5s">CONTACT US</h1>
      </div>
    </div>

    <!-- 联系我们主体 -->
    <div class="ny_lx">
      <div class="container">
        <!-- 联系信息卡片 -->
        <div class="ny_fs">
          <ul class="row">
            <li v-for="(item, index) in contactInfoList" :key="index" class="wow fadeInUp"
              :data-wow-delay="`${0.2 * index}s`">
              <div class="t_b"><img :src="`/images/${item.icon}`"></div>
              <h3>{{ item.title }}</h3>
              <p>{{ item.content }}</p>
            </li>
          </ul>
        </div>

        <!-- 留言表单 -->
        <div class="ny_ly wow fadeInUp" data-wow-delay=".8s">
          <h3>Feel free to contact us</h3>
          <h4>Leave us a message and our team will get back to you within 24 hours.</h4>
          <ul class="row">
            <li>
              <input type="text" v-model="customForm.name" placeholder="Name" required>
            </li>
            <li>
              <input type="tel" v-model="customForm.phone" placeholder="Phone" required>
            </li>
            <li>
              <input type="email" v-model="customForm.email" placeholder="Email" required>
            </li>
            <li>
              <textarea v-model="customForm.mess" placeholder="Write Message" required></textarea>
            </li>
            <li>
              <button @click="addCustomFuc">Send Message</button>
            </li>
          </ul>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
// 引入WOW动画库
import WOW from 'wowjs'
import { addCustom } from '@/api';
export default {
  name: 'Contact',
  data() {
    return {
      // 搜索相关
      searchVisible: false,
      searchKeyword: '',
      // 语言下拉框
      languageDropdownVisible: false,
      // 移动端导航
      mobileNavVisible: false,
      // 联系信息列表（数据化管理）
      contactInfoList: [
        {
          icon: 'fs1.png',
          title: 'Office Address',
          content: '#333 Ankang Road, High-tech Zone, Binzhou, Shandong, China'
        },
        {
          icon: 'fs2.png',
          title: 'Call Us',
          content: '+86 4009-710-788'
        },
        {
          icon: 'fs3.png',
          title: 'Email Us',
          content: 'info@cnhonorgroup.com'
        },
        {
          icon: 'fs4.png',
          title: 'Office Open',
          content: '24/7 Support'
        }
      ],
      // 表单数据
      formData: {
        name: '',
        phone: '',
        email: '',
        message: ''
      },
      // 表单错误提示
      formErrors: {
        name: '',
        phone: '',
        email: '',
        message: ''
      },
      customForm: {
        surname: '',
        name: '',
        email: '',
        phone: '',
        company: '',
        pos: '',
        type: '',
        area: '',
        mess: '',
        state: 0
      },
      // 提交状态
      isSubmitting: false,
      // 提交成功标识
      submitSuccess: false
    }
  },
  mounted() {

    window.scrollTo(0, 0)
    // 初始化WOW动画
    new WOW.WOW({
      boxClass: 'wow',
      animateClass: 'animated',
      offset: 0,
      mobile: true,
      live: true
    }).init()

    // 滚动监听（控制返回顶部按钮显隐）
    window.addEventListener('scroll', this.handleScroll)
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    async addCustomFuc() {
      if (this.customForm.mess == '') {
        this.$message({
          message: 'Please enter your message!',
          type: 'error'
        });
        return;
      }
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      let data = await addCustom(this.customForm);
      loading.close();
      if (data.code == 200) {
        this.$message({
          message: 'Send Success！',
          type: 'success'
        });
        setTimeout(() => {
          window.location.reload();
          window.scrollTo(0, 0)
        }, 1000);
      } else {
        this.$message({
          message: data.message || '添加失败',
          type: 'error'
        });
      }
    },
    // ========== 通用功能 ==========
    // 搜索弹窗切换
    toggleSearch() {
      this.searchVisible = !this.searchVisible
      if (this.searchVisible) {
        this.$nextTick(() => {
          const searchInput = document.querySelector('.sc_nr input')
          searchInput?.focus()
        })
      }
    },
    // 搜索处理
    handleSearch() {
      if (!this.searchKeyword.trim()) {
        alert('Please enter search keywords')
        return
      }
      // 跳转到首页或新闻页并携带搜索关键词
      this.$router.push({
        path: '/news',
        query: { keyword: this.searchKeyword }
      })
      this.searchVisible = false
    },
    // 语言下拉框切换
    toggleLanguage() {
      this.languageDropdownVisible = !this.languageDropdownVisible
    },
    // 移动端导航切换
    toggleMobileNav() {
      this.mobileNavVisible = !this.mobileNavVisible
      document.body.style.overflow = this.mobileNavVisible ? 'hidden' : ''
    },
    // 滚动监听
    handleScroll() {
      const scrollTop = window.scrollY
      const backToTopBtn = document.querySelector('.f_h')
      if (backToTopBtn) {
        backToTopBtn.style.display = scrollTop > 300 ? 'block' : 'none'
      }
    },
    // 回到顶部
    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      })
    },

    // ========== 表单验证 ==========
    // 验证单个字段
    validateField(field) {
      const value = this.formData[field].trim()
      this.formErrors[field] = ''

      // 姓名验证
      if (field === 'name') {
        if (!value) {
          this.formErrors.name = 'Name is required'
        } else if (value.length < 2) {
          this.formErrors.name = 'Name must be at least 2 characters'
        }
      }

      // 手机号验证
      if (field === 'phone') {
        if (!value) {
          this.formErrors.phone = 'Phone number is required'
        } else if (!/^\+?[0-9\s\-()]{8,20}$/.test(value)) {
          this.formErrors.phone = 'Please enter a valid phone number'
        }
      }

      // 邮箱验证
      if (field === 'email') {
        if (!value) {
          this.formErrors.email = 'Email is required'
        } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
          this.formErrors.email = 'Please enter a valid email address'
        }
      }

      // 留言验证
      if (field === 'message') {
        if (!value) {
          this.formErrors.message = 'Message is required'
        } else if (value.length < 10) {
          this.formErrors.message = 'Message must be at least 10 characters'
        }
      }
    },

    // 验证所有字段
    validateForm() {
      let isValid = true

      // 验证所有字段
      Object.keys(this.formErrors).forEach(field => {
        this.validateField(field)
        if (this.formErrors[field]) {
          isValid = false
        }
      })

      return isValid
    },

    // ========== 表单提交 ==========
    handleSubmit() {
      // 先验证表单
      if (!this.validateForm()) {
        // 滚动到第一个错误字段
        const firstError = document.querySelector('.input-error')
        if (firstError) {
          firstError.scrollIntoView({ behavior: 'smooth', block: 'center' })
        }
        return
      }

      // 标记为提交中
      this.isSubmitting = true

      // 模拟接口请求（实际项目中替换为axios/post请求）
      setTimeout(() => {
        // 重置表单
        this.formData = {
          name: '',
          phone: '',
          email: '',
          message: ''
        }
        this.formErrors = {
          name: '',
          phone: '',
          email: '',
          message: ''
        }

        // 标记提交成功
        this.isSubmitting = false
        this.submitSuccess = true

        // 3秒后隐藏成功提示（可选）
        setTimeout(() => {
          this.submitSuccess = false
        }, 5000)
      }, 1500)
    }
  }
}
</script>

<style scoped></style>